import { Component, OnInit, AfterViewInit, ViewChildren, QueryList, ElementRef, Inject } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { LanguageService } from '@app/core/services';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
@Component({
    selector: 'app-statistics',
    templateUrl: './statistics.component.html',
    styleUrls: ['./statistics.component.scss'],
})
export class StatisticsComponent implements OnInit, AfterViewInit {
    @ViewChildren('flip') flips: QueryList<ElementRef>;
    isBrowser = false;

    // ** 服務統計 fliper
    fliper = [
        { Type: 'organization', Count: 34, Title: '建構堅實的安全基石' },
        { Type: 'project', Count: 57, Title: '打造高效的治安管理' },
        { Type: 'solution', Count: 183, Title: '構築精實的國防科技' },
    ];
    // ** 服務統計 標題
    securityTitle = this.fliper[0].Title;
    // ** 服務統計 中文序號 map
    serviceMap = { organization: 0, project: 1, solution: 2 };
    // ** 服務統計 三張卡片是否是進到畫面的 observer
    observer;
    // ** YouTube URL
    youtubeUrl: SafeResourceUrl;
    private langChangeSubscription: Subscription;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        @Inject(PLATFORM_ID) private platformId,
        private languageService: LanguageService,
        private translateService: TranslateService,
        private sanitizer: DomSanitizer,
        public router: Router,
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        this.setYouTubeUrl();
        this.langChangeSubscription = this.languageService.onLanguageChange.subscribe(() => {
            this.setYouTubeUrl();
        });
    }

    ngAfterViewInit() {
        if (this.isBrowser) this.constructObserver();
    }

    async constructObserver() {
        let Flip;
        Flip = (await import('number-flip')).Flip;

        this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const type = Array.from(entry.target.classList)[0];
                const eleRefsArr = this.flips.toArray();
                const ele = eleRefsArr[this.serviceMap[type]].nativeElement;
                const no = this.fliper[this.serviceMap[type]].Count;
                if (entry.isIntersecting && Flip) {
                    eleRefsArr[this.serviceMap[type]].nativeElement.innerHTML = '';
                    new Flip({ node: ele, from: 0, to: no, duration: 2 });
                    this.observer.unobserve(ele);
                }
            });
        });

        this.flips.forEach((eRef, idx) => this.observer?.observe(eRef.nativeElement));
    }

    /** 設定 YouTube URL */
    private setYouTubeUrl(): void {
        const videoUrls = {
            'en-us': 'https://www.youtube.com/embed/KjqJXy230_E?autoplay=1&rel=0', // 新形象影片暫時無英文版
            'zh-tw': 'https://www.youtube.com/embed/KjqJXy230_E?autoplay=1&rel=0', 
        };

        const currentLang = this.translateService.currentLang;
        const url = videoUrls[currentLang] || videoUrls['zh-tw'];

        this.youtubeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}
